import ENDPOINT from "@/api/endpoints";
import { HTTP, buildQueries } from "@/api/http-common";

export function callApiLayDanhSachThongBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(`${ENDPOINT.THONG_BAO.GET_ALL}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiUpdateDaXemThongBao(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.THONG_BAO.UPDATE_DA_XEM}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiMarkAsReadAll() {
  return HTTP({
    url: ENDPOINT.THONG_BAO.MARK_AS_READ_ALL,
    method: "POST"
  });
}
